import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { emojiSheetFn } from '../utils';

@Component({
  selector: 'app-emoji',
  templateUrl: './emoji.component.html',
  styleUrls: ['./emoji.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmojiComponent {
  @Input() size = 30;
  @Input() emojiName?: string | null;
  @Output() clicked = new EventEmitter<string>();

  readonly emojiSheet = emojiSheetFn;
}
